import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { UPDATE_DWNLD_STATE_DATA } from "@frameworks/web/redux/interfaces/Reports/CoreReports/IDownloadNSendEmailReportReducer";
export class DownloadNSendEmailReportActions extends OnePlatformCommonActions {
    setDownloadStateData(data, type) {
        this.dispatch({
            type: UPDATE_DWNLD_STATE_DATA,
            payload: data,
            reducerName: type,
        });
    }
}
